<template>
    <div> 
        <b-modal id="hgs-create-or-update-modal"
                 :title="editingHgs ? 'HGS Kaydı Güncelle' : 'Yeni HGS Kaydı Ekle'"
                 no-close-on-esc
                 no-close-on-backdrop>

            <plate-h-g-s-classification-create-or-update v-model="hgsRecord" :errors="errorsHgs" :editing="editingHgs" :hgs-classes="hgsClasses" :hgs-vehicle-types="hgsVehicleTypes" />

            <template #modal-footer>
                <v-executer :loading="loadingHgs" :editing="editingHgs" :action="createOrUpdateHgs"></v-executer>
            </template>
        </b-modal>

        <v-table ref="hgsTable"
                 :fields="fields"
                 :items="hgsHistoryItems" 
                 :buttons="buttons"
                 :add-callback="createNewHgs"
                 add-text="Yeni HGS Kaydı Ekle"
                 pagination="client"
                 name="hgs-history"
                 search>
        </v-table>
    </div> 
</template>

<script>
import PlateApi from '@/api/vehicle-operations'
import PlateHGSClassificationCreateOrUpdate from './components/PlateHGSClassificationCreateOrUpdate.vue'

export default {
    name: 'PlateHGSClassificationView',
    components: {
        PlateHGSClassificationCreateOrUpdate
    },
    props: {
        plate: {type: Object,required: true},
        hgsClasses: { type: Array, default: () => [] },
        hgsVehicleTypes: { type: Array, default: () => [] }
    },
    data() {
        return {
            loadingTable: false,
            hgsHistoryItems: [],
            editingHgs: false,
            loadingHgs: false,
            errorsHgs: {},
            hgsRecord: {
                Id: null, VehiclePlateId: null, HGSNumber: null, StartDate: null,
                EndDate: null, HGSClass: null, HGSVehicleClassType: null,
            },
            fields: [
                { name: "HGS Numarası", key: "HGSNumber", sortable: true },
                { name: "Başlangıç Tarihi", key: "HGSStartDateValue", sortable: true },
                { name: "Bitiş Tarihi", key: "HGSEndDateValue", sortable: true },
                { name: "HGS Sınıfı", key: "HGSClassName", sortable: true },
                { name: "Araç Tipi", key: "HGSVehicleClassTypeName", sortable: true },
            ],
            buttons: [
                { text: "Düzenle", key: "edit", icon: "Edit2Icon", variant: "secondary", action: this.editHgs },
                { text: "Sil", key: "delete", icon: "TrashIcon", variant: "danger", action: this.deleteHgs },
            ]
        }
    },
    watch: {
        plate: {
            handler(newPlateData) {
                if (newPlateData && newPlateData.Id) {
                    this.fetchHgsData();
                }
            },
            immediate: true 
        }
    },
    methods: {
        fetchHgsData() {
            if (!this.plate || !this.plate.Id) return;
            this.loadingTable = true;
            PlateApi.HGSClassification.GetByPlateId(this.plate.Id)
                .then(res => {
                    if (res.data.Success) {
                        this.hgsHistoryItems = res.data.Data;
                    }
                })
                .catch(err => this.$result(null, err))
                .finally(() => this.loadingTable = false);
        },
        clearHgsForm() {
            this.editingHgs = false;
            this.errorsHgs = {};
            this.hgsRecord = {
                Id: null, VehiclePlateId: null, HGSNumber: null, StartDate: null,
                EndDate: null, HGSClass: null, HGSVehicleClassType: null,
            };
        },
        createNewHgs() {
            this.clearHgsForm();
            this.hgsRecord.VehiclePlateId = this.plate.Id;
            this.$bvModal.show('hgs-create-or-update-modal');
        },
        editHgs(item) {
            this.clearHgsForm();
            this.editingHgs = true;
            
            this.hgsRecord = {
                Id: item.Id,
                VehiclePlateId: this.plate.Id,
                HGSNumber: item.HGSNumber,
                StartDate: item.HGSStartDate, 
                EndDate: item.HGSEndDate,
                HGSClass: item.HGSClass,
                HGSVehicleClassType: item.HGSVehicleClassType
            };

            this.$bvModal.show('hgs-create-or-update-modal');
        },
        createOrUpdateHgs() {
            this.errorsHgs = {};
            this.hgsRecord.HGSNumber = this.normalizeHGSNumber(this.hgsRecord.HGSNumber);

            if (this.hgsRecord.HGSNumber && this.hgsRecord.HGSNumber.length !== 10) {
                this.errorsHgs.HGSNumber = 'HGS etiketi 10 karakter olmalidir.';
                return;
            }

            this.loadingHgs = true;
            PlateApi.HGSClassification.CreateOrUpdate(this.editingHgs, this.hgsRecord)
                .then(res => {
                    if (res.data.Success) {
                        this.fetchHgsData(); 
                        this.$bvModal.hide('hgs-create-or-update-modal');
                    }
                    this.$result(res);
                })
                .catch(err => {
                    this.errorsHgs = this.getValidationErrors(err);
                    this.$result(null, err);
                })
                .finally(() => {
                    this.loadingHgs = false;
                });
        },
        normalizeHGSNumber(value) {
            if (!value) return null;
            const normalizedValue = value.toString().trim().replace(/\s+/g, '').toUpperCase();
            return normalizedValue || null;
        },
        getValidationErrors(err) {
            const responseData = err?.response?.data || {};
            return responseData.Data || responseData.Errors || {};
        },
        deleteHgs(item) {
            this.$confirm('Silme Onayı', `Bu HGS kaydını silmek istediğinize emin misiniz?`).then(result => {
                if (result) {
                    PlateApi.HGSClassification.Delete(item.Id).then(res => {
                        if (res.data.Success) {
                            this.fetchHgsData();
                        }
                        this.$result(res);
                    }).catch(err => this.$result(null, err))
                }
            })
        },
    }
}
</script>
